import { render } from "./Course.vue?vue&type=template&id=614fd888"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
script.render = render

export default script